(() => {
  const node = document.getElementById('FidlyEuropeMobileSticky');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  if (['lt', 'pl'].includes(config.locale.toLowerCase().split('-')[0])) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  const selector = '.lbts-add-to-cart-bar-mobile button';
  const originalLabels = new WeakMap();
  const copy = config.copy;
  const decode = document.createElement('textarea');
  for (const key of Object.keys(copy)) {
    decode.innerHTML = copy[key];
    copy[key] = decode.value;
  }
  const oneJarVariants = config.variants.filter(variant => variant.jars === config.oneJarOption);
  let pending = false;
  let state = 'shopNow';
  let scheduled = false;

  const render = () => {
    scheduled = false;
    for (const button of document.querySelectorAll(selector)) {
      const label = button.querySelector('.lbts-truncate-2');
      if (!label) continue;
      if (!originalLabels.has(button)) originalLabels.set(button, label.textContent);
      const text = mobile.matches ? copy[state] : originalLabels.get(button);
      if (label.textContent !== text) label.textContent = text;
      if (mobile.matches) {
        button.disabled = pending;
        button.setAttribute('aria-busy', String(pending));
      }
    }
  };

  const scheduleRender = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(render);
  };

  const selectItem = () => {
    const selectedWeight = document.querySelector('.custom-weight-btn.active')?.dataset.weight;
    const variant = oneJarVariants.find(item => item.weight === selectedWeight)
      || oneJarVariants[1] || oneJarVariants[0];
    if (!variant?.available) throw new Error(copy.unavailable);
    const plan = variant.plans.find(item => /(?:^|[-–—])\s*1(?:\s|[^\d])/u.test(item.name));
    if (!plan) throw new Error(copy.noPlan);
    return {id: variant.id, quantity: 1, selling_plan: Number(plan.id)};
  };

  const syncPurchaseChoice = item => {
    const variant = oneJarVariants.find(variant => variant.id === item.id);
    const card = Array.from(document.querySelectorAll('.custom-jar-card'))
      .find(card => card.dataset.jars === variant.jars);
    card?.click();
    document.querySelector('.custom-purchase-btn[data-purchase-type="MĖNESINIS"]')?.click();
    const select = document.querySelector('#appstle_selling_plan0');
    if (select && Array.from(select.options).some(option => option.value === String(item.selling_plan))) {
      select.value = String(item.selling_plan);
      select.dispatchEvent(new Event('change', {bubbles: true}));
    }
    const radio = document.querySelector('#appstle_selling_plan_label_20');
    if (radio && !radio.checked) radio.click();
  };

  document.addEventListener('click', async event => {
    const button = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!button || !mobile.matches) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;

    let item;
    try {
      item = selectItem();
    } catch (error) {
      window.alert(error.message);
      return;
    }

    syncPurchaseChoice(item);
    const drawer = document.querySelector('cart-drawer');
    drawer?.setActiveElement?.(button);
    pending = true;
    state = 'adding';
    render();
    let data;
    try {
      const response = await fetch(config.addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({
          items: [item],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      data = await response.json();
      if (!response.ok) throw new Error(data.description || copy.cartError);
    } catch (error) {
      pending = false;
      state = 'shopNow';
      render();
      window.alert(error.message || copy.cartError);
      return;
    }

    state = 'added';
    render();
    try {
      const root = config.cartUrl.replace(/\/cart\/?$/, '/');
      const response = await fetch(root + '?sections=cart-drawer,cart-icon-bubble', {
        credentials: 'same-origin',
        headers: {'Accept': 'application/json'}
      });
      if (!response.ok) throw new Error(copy.cartError);
      const sections = await response.json();
      const parser = new DOMParser();
      const refreshed = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
      if (!drawer || !refreshed) throw new Error(copy.cartError);
      drawer.replaceWith(refreshed);
      const icon = document.querySelector('#cart-icon-bubble');
      const refreshedIcon = sections['cart-icon-bubble']
        ? parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble')
        : null;
      if (icon && refreshedIcon) icon.replaceWith(refreshedIcon);
      refreshed.setActiveElement?.(button);
      refreshed.open();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch {
      window.location.assign(config.cartUrl);
      return;
    }
    window.setTimeout(() => {
      pending = false;
      state = 'shopNow';
      render();
    }, 1200);
  }, true);

  new MutationObserver(records => {
    if (records.some(record => {
      const element = record.target.nodeType === Node.ELEMENT_NODE
        ? record.target : record.target.parentElement;
      if (element?.closest('.lbts-add-to-cart-bar-mobile')) return true;
      return Array.from(record.addedNodes).some(added =>
        added.nodeType === Node.ELEMENT_NODE &&
        (added.matches('.lbts-add-to-cart-bar-mobile') || added.querySelector('.lbts-add-to-cart-bar-mobile'))
      );
    })) scheduleRender();
  }).observe(document.body, {childList: true, subtree: true, characterData: true});
  mobile.addEventListener('change', render);
  render();
})();
